const ZDANIA66 = [
  {
    name: "[6 klasa] Niem Kwie 2024",
    lang: 'de',
    zdania: [
      {
        pl: "Tato, musisz podpisać moje świadectwo",
        de: "Vati, du musst mein Zeugnis unterschreiben",
      },
      {
        pl: "Co? Znowu piątka z matematyki?",
        de: "Was? Schon wieder eine Fünf in Mathe?",
      },
      {
        pl: "Stefan, musisz więcej się uczyć",
        de: "Stefan, du musst mehr lernen",
      },
      {
        pl: "Tak, tak, to zrobię",
        de: "Ja, ja, das werde ich tun",
      },
      {
        pl: "I nie będę tak często wychodził po południu",
        de: "Und ich werde auch nachmittags nicht mehr so oft weggehen",
      },
      {
        pl: "Dobre postanowienia",
        de: "Gute Vorsätze",
      },
      {
        pl: "Co zamierzasz robić?",
        de: "Was wirst du tun?",
      },
      {
        pl: "Będę mniej oglądać telewizję każdego dnia",
        de: "Ich werde jeden Tag weniger fernsehen",
      },
      {
        pl: "W weekend posprzątam mój pokój",
        de: "Am Wochenende werde ich mein Zimmer aufräumen",
      },
      {
        pl: "Tomek nie będzie grać na komputerze przez tydzień",
        de: "Tomek wird die Woche über nicht am Computer spielen",
      },
      {
        pl: "Magda nie będzie jeść czekolady",
        de: "Magda wird keine Schokolade essen",
      },
      {
        pl: "Tina, co zamierzasz robić po szkole?",
        de: "Tina, was wirst du nach der Schule machen?",
      },
      {
        pl: "Najpierw urządzę święto",
        de: "Ich werde zunächst ein Fest geben",
      },
      {
        pl: "Zrobię dużą podróż, do Rzymu",
        de: "Werde ich eine große Reise machen, nach Rom",
      },
      {
        pl: "Skoncentruję się na tenisie",
        de: "Werde ich mich aufs Tennis konzentrieren",
      },
      {
        pl: "Będę bardzo intensywnie trenować",
        de: "Ich werde sehr intensiv trainieren",
      },
      {
        pl: "Nauczę się nowego języka",
        de: "Werde ich eine neue Sprache lernen",
      },
      {
        pl: "Stefan i Tina zorganizują dużą imprezę",
        de: "Stefan und Tina werden eine große Party geben",
      },
      {
        pl: "Zaproszą wielu przyjaciół",
        de: "Sie werden viele Freunde einladen",
      },
      {
        pl: "Będą jedli i pili przez całe popołudnie",
        de: "Sie werden den ganzen Nachmittag essen und trinken",
      },
      {
        pl: "Będą się bawić, by dobrze się bawić",
        de: "Sie werden spielen, um Spaß zu haben",
      },
      {
        pl: "Co zamierzasz robić po szkole?",
        de: "Was wirst du nach der Schule machen?",
      },
      {
        pl: "Zdaję maturę. A ty?",
        de: "Ich werde mein Abitur machen. Und du?",
      },
      {
        pl: "Będę studiować",
        de: "Ich werde studieren",
      },
      {
        pl: "Nauczę się zawodu",
        de: "Ich werde einen Beruf erlernen",
      },
      {
        pl: "Będę muzykiem",
        de: "Ich werde Musikerin sein",
      },
      {
        pl: "Będę malować piękne obrazy",
        de: "Ich werde schöne Bilder malen",
      },
      {
        pl: "W 2030 roku będę pracować jako nauczycielka tenisa",
        de: "Im Jahr 2030 werde ich als Tennislehrerin arbeiten",
      },
      {
        pl: "W 2030 roku mój brat będzie muzykiem",
        de: "Im Jahr 2030 wird mein Bruder Musiker sein",
      },
      {
        pl: "W 2030 roku moi rodzice będą mieszkać za granicą",
        de: "Im Jahr 2030 werden meine Eltern im Ausland leben",
      },
      {
        pl: "W 2030 roku Stefan będzie bogaty",
        de: "Im Jahr 2030 wird Stefan reich sein",
      },
      {
        pl: "W 2030 roku Tina będzie pracować jako architektka i mieszkać w Berlinie",
        de: "Im Jahr 2030 wird Tina als Architektin arbeiten und in Berlin wohnen",
      },
      {
        pl: "W 2030 roku Malinowie będą perfekcyjnie mówić po angielsku i mieszkać samodzielnie",
        de: "Im Jahr 2030 werden die Malins perfekt Englisch sprechen und allein leben",
      },
      {
        pl: "W 2030 roku będą żonaci",
        de: "Im Jahr 2030 werden sie verheiratet sein",
      },
      {
        pl: "W 2030 roku będą mieli dwoje dzieci",
        de: "Im Jahr 2030 werden sie zwei Kinder haben",
      },
      {
        pl: "W 2030 roku będą mieszkać na wyspie marzeń",
        de: "Im Jahr 2030 werden sie auf einer Trauminsel leben",
      },
      {
        pl: "Co będziesz robić w 2030 roku?",
        de: "Was wirst du im Jahr 2030 machen?",
      },
      {
        pl: "W 2030 roku będziesz mieszkać za granicą",
        de: "Ich werde im Ausland dein Bruder im Jahr 2030 machen?",
      },
      {
        pl: "Czy ludzie będą żyć dłużej?",
        de: "Werden die Menschen älter werden?",
      },
      {
        pl: "Czy będzie mniej chorób?",
        de: "Wird es weniger Krankheiten geben?",
      },
      {
        pl: "Czy świat będzie piękniejszy?",
        de: "Wird die Welt schöner sein?",
      },
      {
        pl: "Czy ludzie będą mieć więcej pieniędzy?",
        de: "Werden die Menschen mehr Geld haben?",
      },
      {
        pl: "Czy klimat będzie dużo cieplejszy?",
        de: "Wird das Klima viel wärmer sein?",
      },
      {
        pl: "Czy ludzie będą mieć więcej czasu wolnego?",
        de: "Werden die Menschen mehr Freizeit haben?",
      },
      {
        pl: "Czy ludzie będą pracować krócej?",
        de: "Werden die Menschen kürzer arbeiten?",
      },
      {
        pl: "Jesteś bardzo optymistyczny",
        de: "Du bist sehr optimistisch",
      },
      {
        pl: "Jesteś dość optymistyczny",
        de: "Du bist ziemlich optimistisch",
      },
      {
        pl: "Jesteś dość pesymistyczny",
        de: "Du bist ziemlich pessimistisch",
      },
      {
        pl: "Jesteś bardzo pesymistyczny",
        de: "Du bist sehr pessimistisch",
      },
      {
        pl: "Zawsze widzisz wszystko w czarnych barwach!",
        de: "Du siehst immer schwarz!",
      },
      {
        pl: "I kto jest najbardziej pesymistyczny?",
        de: "Und wer ist am pessimistischsten?",
      },
      {
        pl: "Laura ma 20 punktów",
        de: "Laura hat 20 Punkte",
      },
      {
        pl: "Ona jest najbardziej optymistyczna",
        de: "Sie ist am optimistischsten",
      },
      {
        pl: "Marek jest najbardziej pesymistyczny",
        de: "Marek ist am pessimistischsten",
      },
      {
        pl: "On ma tylko 9 punktów",
        de: "Er hat nur 9 Punkte",
      },
      {
        pl: "Kamil ma 19 punktów",
        de: "Kamil hat 19 Punkte",
      },
      {
        pl: "On jest bardziej optymistyczny niż Piotrek",
        de: "Er ist optimistischer als Piotrek",
      },
      {
        pl: "Jaką ocenę masz z angielskiego?",
        de: "Welche Note hast du in Englisch?",
      },
      {
        pl: "Jaką ocenę masz z wychowania fizycznego?",
        de: "Welche Note hast du in Sport?",
      },
      {
        pl: "Jak wysoki jesteś?",
        de: "Wie groß bist du?",
      },
      {
        pl: "Ile masz lat?",
        de: "Wie alt bist du?",
      },
      {
        pl: "Jak długo uczysz się angielskiego?",
        de: "Wie lange lernst du Englisch?",
      },
      {
        pl: "długi (komparativ)",
        de: "länger",
      },
      {
        pl: "stary (komparativ)",
        de: "älter",
      },
      {
        pl: "wysoki (komparativ)",
        de: "größer",
      },
      {
        pl: "młody (komparativ)",
        de: "jünger",
      },
      {
        pl: "szczęśliwy (komparativ)",
        de: "glücklicher",
      },
      {
        pl: "mało (komparativ)",
        de: "weniger",
      },
      {
        pl: "piękny (komparativ)",
        de: "schöner",
      },
      {
        pl: "elegancki (komparativ)",
        de: "eleganter",
      },
      {
        pl: "ciepły (komparativ)",
        de: "wärmer",
      },
      {
        pl: "ładny (komparativ)",
        de: "hübscher",
      },
      {
        pl: "dużo (komparativ)",
        de: "mehr",
      },
      {
        pl: "dobry (komparativ)",
        de: "besser",
      },
      {
        pl: "długi (Superlativ)",
        de: "am längsten",
      },
      {
        pl: "stary (Superlativ)",
        de: "am ältesten",
      },
      {
        pl: "wysoki (Superlativ)",
        de: "am größten",
      },
      {
        pl: "młody (Superlativ)",
        de: "am jüngsten",
      },
      {
        pl: "szczęśliwy (Superlativ)",
        de: "am glücklichsten",
      },
      {
        pl: "mało (Superlativ)",
        de: "am wenigsten",
      },
      {
        pl: "piękny (Superlativ)",
        de: "am schönsten",
      },
      {
        pl: "elegancki (Superlativ)",
        de: "am elegantesten",
      },
      {
        pl: "ciepły (Superlativ)",
        de: "am wärmsten",
      },
      {
        pl: "ładny (Superlativ)",
        de: "am hübschesten",
      },
      {
        pl: "dużo (Superlativ)",
        de: "am meisten",
      },
      {
        pl: "dobry (Superlativ)",
        de: "am besten",
      },
    ],
  },
];

const ZDANIA67 = [
  {
    name: "[6 klasa] Niem Kwie 2024 - II",
    lang: 'de',
    zdania: [
      {
        pl: "Poniedziałek",
        de: "Der Montag",
      },
      {
        pl: "Wtorek",
        de: "Der Dienstag",
      },
      {
        pl: "Środa",
        de: "Der Mittwoch",
      },
      {
        pl: "Czwartek",
        de: "Der Donnerstag",
      },
      {
        pl: "Piątek",
        de: "Der Freitag",
      },
      {
        pl: "Sobota",
        de: "Der Samstag",
      },
      {
        pl: "Niedziela",
        de: "Der Sonntag",
      },
      {
        pl: "Dzień",
        de: "Der Tag",
      },
      {
        pl: "Tydzień",
        de: "Die Woche",
      },
      {
        pl: "Miesiąc",
        de: "Der Monat",
      },
      {
        pl: "Rok",
        de: "Das Jahr",
      },
      {
        pl: "W poniedziałek idę do lekarza",
        de: "Am Montag gehe ich zum Arzt",
      },
      {
        pl: "Wtorek przychodzi po poniedziałku",
        de: "Der Dienstag kommt nach dem Montag",
      },
      {
        pl: "Środa jest trzecim dniem tygodnia",
        de: "Mittwoch ist der dritte Wochentag",
      },
      {
        pl: "W czwartek zawsze mam dużo pracy",
        de: "Am Donnerstag habe ich immer viel Arbeit",
      },
      {
        pl: "Przyjeżdżamy w piątek o siedemnastej",
        de: "Wir kommen am Freitag um sieben Uhr",
      },
      {
        pl: "W sobotę mamy wolne",
        de: "Am Samstag haben wir frei",
      },
      {
        pl: "Moje dzieci odwiedzają mnie w niedzielę",
        de: "Meine Kinder besuchen mich am Sonntag",
      },
      {
        pl: "Pracuję w dzień",
        de: "Ich arbeite am Tag",
      },
      {
        pl: "Tydzień ma siedem dni",
        de: "Die Woche hat sieben Tage",
      },
      {
        pl: "Styczeń jest pierwszym miesiącem",
        de: "Januar ist der erste Monat",
      },
      {
        pl: "To jest mój pierwszy rok w Niemczech",
        de: "Das ist mein erstes Jahr in Deutschland",
      },
      {
        pl: "Rano",
        de: "Der Morgen",
      },
      {
        pl: "Południe",
        de: "Der Mittag",
      },
      {
        pl: "Popołudnie",
        de: "Der Nachmittag",
      },
      {
        pl: "Wieczór",
        de: "Der Abend",
      },
      {
        pl: "Noc",
        de: "Die Nacht",
      },
      {
        pl: "Wiosna",
        de: "Der Frühling",
      },
      {
        pl: "Lato",
        de: "Der Sommer",
      },
      {
        pl: "Jesień",
        de: "Der Herbst",
      },
      {
        pl: "Zima",
        de: "Der Winter",
      },
      {
        pl: "Pora roku",
        de: "Die Jahreszeit",
      },
      {
        pl: "Data",
        de: "Das Datum",
      },
      {
        pl: "Rano jest słonecznie",
        de: "Der Morgen ist sonnig",
      },
      {
        pl: "Wczoraj w południe miałem odwiedziny",
        de: "Gestern Mittag hatte ich Besuch",
      },
      {
        pl: "W popołudnie zawsze śpię godzinę",
        de: "Am Nachmittag schlafe ich immer eine Stunde",
      },
      {
        pl: "Dziś wieczorem zostaję w domu",
        de: "Heute Abend bleibe ich zu Hause",
      },
      {
        pl: "Noc była bardzo zimna",
        de: "Die Nacht war sehr kalt",
      },
      {
        pl: "Wiosną jest ciepło",
        de: "Im Frühling ist es warm",
      },
      {
        pl: "Latem jedziemy nad morze",
        de: "Im Sommer fahren wir ans Meer",
      },
      {
        pl: "Jesienią liście są kolorowe",
        de: "Im Herbst sind die Blätter bunt",
      },
      {
        pl: "Rok ma cztery pory roku",
        de: "Das Jahr hat vier Jahreszeiten",
      },
      {
        pl: "Jaką mamy dzisiaj datę?",
        de: "Welches Datum haben wir heute?",
      },
    ],
  },
];

export { ZDANIA67, ZDANIA66 };
